// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ov-1";
export var messageSideRight = "_ov-2";
export var orderLookupBubbleContainer = "_ov-0";
export var submitButton = "_ov-3";